import { Env } from '@stencil/core';

import type { Enum } from '../services/interfaces';

export const PUBLIC_BASE_URL: string = Env.PUBLIC_BASE_URL || '/';

export const CSSVALUEPREFIX: string = '--pk-';

export const KEYBOARD = {
  ArrowDown: 'ArrowDown',
  ArrowUp: 'ArrowUp',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Enter: 'Enter',
  Escape: 'Escape',
  Space: ' ',
  Tab: 'Tab',
} as const;
export type KEYBOARD = Enum<typeof KEYBOARD>;
